import firebase from 'firebase'

const config = {
    apiKey: "AIzaSyA8FNCFyXD4YmYmD-BIg172p7Jq6-M9Ivc",
    authDomain: "identical-faces.firebaseapp.com",
    databaseURL: "https://identical-faces.firebaseio.com",
    projectId: "identical-faces",
    storageBucket: "identical-faces.appspot.com",
    messagingSenderId: "498983817067"
}

const app = firebase.initializeApp(config)
const database = firebase.database()

export default app
export { database }



// WEBPACK FOOTER //
// ./src/firebase.js